<script>
    import Brand from 'components/brand/index.svelte'
    // ═══ Вход / регистрация / восстановление — дизайн Living City, ВШИТ в src_cef.
    // Заменяет старый start/. Действия те же, что были: те же executeClient-вызовы.
    import { executeClient } from 'api/rage'
    import { accountLogin } from 'store/account'
    import { addListernEvent } from 'api/functions'

    let tab = 'login';              // login | register | restore
    let known = null;               // известный логин с сервера (-1 = аккаунта нет)

    // вход
    let login = '', pass = '';
    // регистрация
    let rLogin = '', rMail = '', rPass1 = '', rPass2 = '', rPromo = '';
    // восстановление
    let restore = '', restoreStage = 0;   // 0 — запросить код, 1 — подтвердить

    let error = '';
    let sending = false;

    // сервер говорит, есть ли аккаунт по Social Club: -1 = нет → сразу регистрация
    accountLogin.subscribe((v) => {
        if (v === -99 || v === undefined || v === null) return;
        known = v;
        tab = (v === -1 || v === '-1') ? 'register' : 'login';
    });

    // письмо отправлено (тот же слушатель, что был в старом экране)
    let mailSent = false;
    addListernEvent('isSendEmailMessage', (t) => { mailSent = !!t; sending = false; });

    const doLogin = () => {
        error = '';
        if (!login || !pass) { error = 'Введите логин и пароль'; return; }
        if ($accountLogin === -99) { error = 'Подождите, идёт проверка…'; return; }
        sending = true;
        executeClient('client:OnSignInv2', login, pass);
        setTimeout(() => sending = false, 3000);
    };

    const doRegister = () => {
        error = '';
        if (!rLogin || !rMail || !rPass1 || !rPass2) { error = 'Заполните все поля'; return; }
        if (rPass1 !== rPass2) { error = 'Пароли не совпадают'; return; }
        if ($accountLogin === -99) { error = 'Подождите, идёт проверка…'; return; }
        sending = true;
        executeClient('client:OnSignUpv2', rLogin, rMail, rPromo, rPass1, rPass2);
        setTimeout(() => sending = false, 3000);
    };

    const doRestore = () => {
        error = '';
        if (!restore) { error = 'Введите логин или почту'; return; }
        executeClient('restorepass', restoreStage, restore);
        if (restoreStage === 0) restoreStage = 1;
    };

    // ошибки с сервера показываем в форме
    addListernEvent('queueText', () => {});
    window.lcAuthError = (t) => { error = String(t || ''); sending = false; };

    const onKey = (e) => {
        if (e.keyCode !== 13) return;
        if (tab === 'login') doLogin();
        else if (tab === 'register') doRegister();
        else doRestore();
    };
</script>

<svelte:window on:keyup={onKey} />

<div class="lcauth">
    <div class="lcauth-card">
        <div class="lcauth-brand">
            <Brand size={54} title="Лос-Сантос ждёт тебя" />
        </div>

        <div class="lcauth-tabs">
            <div class="lcauth-tab" class:on={tab==='login'} on:click={() => {tab='login'; error='';}}>Вход</div>
            <div class="lcauth-tab" class:on={tab==='register'} on:click={() => {tab='register'; error='';}}>Регистрация</div>
            <div class="lcauth-tab" class:on={tab==='restore'} on:click={() => {tab='restore'; error='';}}>Восстановить</div>
        </div>

        {#if mailSent}
            <div class="lcauth-note">
                <b>Мы отправили письмо на почту</b>
                <p>Подтвердите адрес, чтобы перейти к созданию персонажа.</p>
            </div>
        {:else if tab === 'login'}
            <div class="lcauth-body">
                <label>Логин</label>
                <input bind:value={login} placeholder="Ваш логин" spellcheck="false" />
                <label>Пароль</label>
                <input type="password" bind:value={pass} placeholder="Пароль" />
                <button class="lcauth-btn" class:wait={sending} on:click={doLogin}>{sending ? 'Входим…' : 'Войти'}</button>
                <div class="lcauth-alt" on:click={() => {tab='restore'; error='';}}>Забыли пароль?</div>
            </div>
        {:else if tab === 'register'}
            <div class="lcauth-body">
                <div class="lcauth-two">
                    <div><label>Логин</label><input bind:value={rLogin} placeholder="Логин" spellcheck="false" /></div>
                    <div><label>Почта</label><input bind:value={rMail} placeholder="mail@mail.com" spellcheck="false" /></div>
                </div>
                <div class="lcauth-two">
                    <div><label>Пароль</label><input type="password" bind:value={rPass1} placeholder="Пароль" /></div>
                    <div><label>Повторите</label><input type="password" bind:value={rPass2} placeholder="Ещё раз" /></div>
                </div>
                <label>Промокод <span class="lcauth-opt">(если есть)</span></label>
                <input bind:value={rPromo} placeholder="Промокод" spellcheck="false" />
                <button class="lcauth-btn" class:wait={sending} on:click={doRegister}>{sending ? 'Создаём…' : 'Создать аккаунт'}</button>
            </div>
        {:else}
            <div class="lcauth-body">
                <label>{restoreStage === 0 ? 'Логин или почта' : 'Код из письма'}</label>
                <input bind:value={restore} placeholder={restoreStage === 0 ? 'Логин или почта' : 'Код'} spellcheck="false" />
                <button class="lcauth-btn" on:click={doRestore}>{restoreStage === 0 ? 'Прислать код' : 'Подтвердить'}</button>
                <div class="lcauth-alt" on:click={() => {tab='login'; error='';}}>Вернуться ко входу</div>
            </div>
        {/if}

        {#if error}<div class="lcauth-err">{error}</div>{/if}
    </div>
</div>

<style>
    .lcauth { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center;
        font-family: 'Manrope','Gilroy',sans-serif; color: #ecfff3; z-index: 60; }
    .lcauth-card { width: 42vh; padding: 3vh 3.2vh; border-radius: 1.6vh;
        background: rgba(14,12,10,.88); border: 1px solid rgba(231,174,63,.22);
        box-shadow: 0 12px 44px rgba(0,0,0,.6); }
    .lcauth-brand { display:flex; align-items:center; gap:1.2vh; margin-bottom:2.4vh; }
    .lcauth-jr { width:4.4vh; height:4.4vh; border-radius:1.1vh; flex:0 0 auto;
        background:linear-gradient(135deg,#f0c863,#c8852f); color:#241a06;
        display:flex; align-items:center; justify-content:center; font-weight:900; font-size:2.2vh; }
    .lcauth-brand b { display:block; font-size:2vh; font-weight:800; letter-spacing:.05em; }
    .lcauth-brand b i { color:#e7ae3f; font-style:normal; }
    .lcauth-brand p { margin:.2vh 0 0; font-size:1.15vh; color:rgba(255,255,255,.45); }
    .lcauth-tabs { display:flex; gap:.6vh; margin-bottom:2vh; padding:.4vh;
        background:rgba(255,255,255,.05); border-radius:1vh; }
    .lcauth-tab { flex:1; text-align:center; padding:.9vh 0; border-radius:.8vh; cursor:pointer;
        font-size:1.2vh; font-weight:700; color:rgba(255,255,255,.5); transition:.18s; }
    .lcauth-tab:hover { color:rgba(255,255,255,.8); }
    .lcauth-tab.on { background:linear-gradient(135deg,#f0c863,#c8852f); color:#241a06; }
    .lcauth-body label { display:block; margin:1.4vh 0 .6vh; font-size:1.05vh; font-weight:700;
        letter-spacing:.12em; text-transform:uppercase; color:rgba(255,255,255,.45); }
    .lcauth-opt { text-transform:none; letter-spacing:0; color:rgba(255,255,255,.3); }
    .lcauth-body input { width:100%; box-sizing:border-box; padding:1.2vh 1.4vh; border-radius:.9vh;
        background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.1);
        color:#fff; font:600 1.35vh 'Manrope',sans-serif; outline:none; transition:.18s; }
    .lcauth-body input:focus { border-color:#e7ae3f; background:rgba(255,255,255,.09); }
    .lcauth-two { display:flex; gap:1vh; }
    .lcauth-two > div { flex:1; min-width:0; }
    .lcauth-btn { width:100%; margin-top:2.2vh; padding:1.3vh 0; border:none; border-radius:1vh;
        background:linear-gradient(135deg,#f0c863,#c8852f); color:#241a06;
        font:800 1.4vh 'Manrope',sans-serif; cursor:pointer; transition:.18s; }
    .lcauth-btn:hover { filter:brightness(1.08); }
    .lcauth-btn.wait { opacity:.6; cursor:default; }
    .lcauth-alt { margin-top:1.4vh; text-align:center; font-size:1.15vh; color:rgba(255,255,255,.45);
        cursor:pointer; }
    .lcauth-alt:hover { color:#e7ae3f; }
    .lcauth-err { margin-top:1.6vh; padding:1vh 1.2vh; border-radius:.8vh; font-size:1.15vh;
        background:rgba(217,83,63,.14); border:1px solid rgba(217,83,63,.4); color:#ffb3a7; }
    .lcauth-note { padding:1.6vh; border-radius:1vh; background:rgba(108,194,138,.12);
        border:1px solid rgba(108,194,138,.35); }
    .lcauth-note b { display:block; font-size:1.4vh; margin-bottom:.6vh; }
    .lcauth-note p { margin:0; font-size:1.15vh; color:rgba(255,255,255,.6); }
</style>
